import { call, put, takeLatest, all } from 'redux-saga/effects';
import api from '../../../utils/tt-api';
import Actions, { ActionTypes } from './actions';
import notification from '@tt/components/Notification';
import { CONSTANT_VARIABLES } from '../../../views/common/Constant_Variables/constants';

function* fetchAll({ interestRegionParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.get, {
      route: `RegionOfInterest/GetSearched`,
      params: interestRegionParams,
    });
    const allInterestRegion = data;
    yield put(Actions.setAll({ allInterestRegion }));
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

function* addorUpdateInterestRegion({ interestRegionData, actionName, interestRegionParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    yield call(actionName === CONSTANT_VARIABLES.UPDATE ? api.put : api.post, {
      route: `RegionOfInterest`,
      data: interestRegionData,
    });
    yield put(Actions.fetchAll({ interestRegionParams }));
    notification(
      'success',
      actionName === CONSTANT_VARIABLES.ADD ? CONSTANT_VARIABLES.ROI_CREATED : CONSTANT_VARIABLES.ROI_UPDATED,
      ''
    );
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}

function* deleteInterestRegion({ id, interestRegionParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    yield call(api.delete, {
      route: `RegionOfInterest/${id}`,
    });
    yield put(Actions.fetchAll({ interestRegionParams }));
    notification('success', CONSTANT_VARIABLES.ROI_DELETED, '');
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}

export default function* rootSaga() {
  yield all([
    takeLatest(ActionTypes.FETCH_ALL, fetchAll),
    takeLatest(ActionTypes.ADD_OR_UPDATE_INTEREST_REGION, addorUpdateInterestRegion),
    takeLatest(ActionTypes.DELETE_INTEREST_REGION, deleteInterestRegion),
  ]);
}
